"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _victory = require("victory");

var _victoryTheme = require("../theme/victoryTheme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ChartTitle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ChartTitle, _React$Component);

  function ChartTitle() {
    _classCallCheck(this, ChartTitle);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChartTitle).apply(this, arguments));
  }

  _createClass(ChartTitle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          subtitle = _this$props.subtitle;
      var style = Object.assign({}, _victoryTheme.baseLabelStyles, {
        fontWeight: 'bold'
      });
      var yValue = 24;
      style.fontSize = '24px';

      if (subtitle === true) {
        style.fontSize = '18px';
        style.fontWeight = 'regular';
        yValue = 50;
      }

      return _react.default.createElement(_victory.VictoryLabel, {
        x: 25,
        y: yValue,
        style: style,
        text: text
      });
    }
  }]);

  return ChartTitle;
}(_react.default.Component);

ChartTitle.propTypes = {
  text: _propTypes.default.string,
  subtitle: _propTypes.default.bool
};
var _default = ChartTitle;
exports.default = _default;